import App from 'app/app.js';

function LtOutsideClickDirective($document) {
  return {
    restrict: 'A',
    scope: {
      outsideClick: '&'
    },
    link: function (scope, element) {
      function clickHandler(event) {
        if (element !== event.target && !element[0].contains(event.target)) {
          scope.$apply(function () {
            scope.$eval(scope.outsideClick);
          });
        }
      }

      $document.on('click', clickHandler);

      scope.$on('$destroy', function () {
        $document.off('click', clickHandler);
      });
    }
  };
}

App.directive('outsideClick', ['$document', LtOutsideClickDirective]);
